class ForbiddenError extends Error {
  constructor() {
    super("User is not authorized");
    this.status = 403;
  }
}

export default ForbiddenError;
